import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import es from './locales/es.json';
import de from './locales/de.json';

export type MessageSchema = typeof en;

// This function goes here in i18n.ts
const getBrowserLocale = (): string => {
  // Optional: Check for ?lang=es in URL
  const urlParams = new URLSearchParams(window.location.search);
  const urlLang = urlParams.get('lang');
  if (urlLang && ['en', 'es', 'de'].includes(urlLang)) {
    return urlLang;
  }
  
  const browserLang = navigator.language.split('-')[0];
  const supportedLocales = ['en', 'es', 'de'];
  return supportedLocales.includes(browserLang) ? browserLang : 'en';
};

const i18n = createI18n<[MessageSchema], 'en' | 'es' | 'de'>({
  legacy: false,
  locale: getBrowserLocale(), // Called here
  fallbackLocale: 'en',
  messages: {
    en,
    es,
    de,
  },
  globalInjection: true,
});

export default i18n;